"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
function getClauseSectionProperties(sectionType) {
    switch (sectionType) {
        case 'conditional':
            return {
                addClauseText: owa_options_strings_1.default.options_inboxRules_addCondition,
                headerText: owa_options_strings_1.default.options_inboxRules_conditionsHeader,
                calloutText: owa_options_strings_1.default.options_inboxRules_conditionsInfo,
                isOptional: false,
            };
        case 'action':
            return {
                addClauseText: owa_options_strings_1.default.options_inboxRules_addAction,
                headerText: owa_options_strings_1.default.options_inboxRules_actionsHeader,
                calloutText: owa_options_strings_1.default.options_inboxRules_actionsInfo,
                isOptional: false,
            };
        case 'exception':
            return {
                addClauseText: owa_options_strings_1.default.options_inboxRules_addException,
                headerText: owa_options_strings_1.default.options_inboxRules_exceptionsHeader,
                calloutText: owa_options_strings_1.default.options_inboxRules_exceptionsInfo,
                isOptional: true,
            };
        case 'name':
            return null;
        default:
            throw new Error('Cannot get section properties for section that does not exist');
    }
}
exports.default = getClauseSectionProperties;
//# sourceMappingURL=getClauseSectionProperties.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/getClauseSectionProperties.js
// module id = 3747
// module chunks = 2